// components/LeaveLimitModal.jsx
import React from 'react';
import moment from 'moment';

const LeaveLimitModal = ({
  isOpen,
  onClose,
  shiftType,
  currentDate,
  goToPreviousMonth,
  goToNextMonth,
  calendarDates,
  getRemainingLeave,
  getRemainingStay,
  getRemainingNight,
  getDailyLimitSplit,
  openSingleDateSetting,
  saveLeaveLimitsToServer,
  selectedLimits,
  setSelectedLimits,
  minOnDuty,
  setMinOnDuty,
  setLimitModalOpen,
  leaveApplicationsByDate
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex justify-center items-start">
      <div className="bg-white p-4 border w-[95%] max-w-3xl h-[80vh] overflow-y-auto rounded-xl shadow-xl">
        {/* 月份切換與標題 */}
        <div className="flex justify-between items-center mb-4">
          <button onClick={goToPreviousMonth} className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300">← 上個月</button>
          <div className="text-lg font-bold">{moment(currentDate).format("YYYY 年 M 月")}</div>
          <button onClick={goToNextMonth} className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300">下個月 →</button>
        </div>

        {/* 最低警力設定 */}
        <div className="flex justify-between items-center mb-4">
          <button
            onClick={async () => {
              const input = prompt("請輸入最低警力", minOnDuty);
              const value = parseInt(input);
              if (!isNaN(value) && value >= 0) {
                setMinOnDuty(value);
                try {
                  const res = await fetch('/api/system-setting', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ key: 'minOnDuty', value })
                  });
                  const result = await res.json();
                  if (!result.success) throw new Error("儲存失敗");
                  alert("✅ 最低警力已更新");

                  setLimitModalOpen(false);
                } catch (err) {
                  alert("❌ 儲存錯誤：" + err.message);
                }
              } else {
                alert("請輸入有效的數字");
              }
            }}
            className="px-2 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            (自動計算)按我設定最低警力：{minOnDuty}
          </button>
          <button
            className="relative top-0 text-red-500 hover:text-red-700 transition text-2xl"
            onClick={onClose}
          >
            關閉
          </button>
        </div>

        <div className="bg-blue-200 text-black p-2 mb-2 shadow">(手動計算)或是個別設定日期</div>

        {/* 日期格子 */}
        <div className="grid grid-cols-2 gap-2">
          {calendarDates.map((date) => {
            const { leave, night } = getDailyLimitSplit(date); // 💡 上限設定
            const applicants = (leaveApplicationsByDate[date] || []).filter(l => !l.user.includes('分隊長')).length;
            const totalQuota = leave + night;
            const leaveRemain = Math.max(0, leave - applicants);
            const whiteRemain = Math.max(0, totalQuota - applicants - leaveRemain);

            const isManual = typeof selectedLimits[date]?.leave === 'number' || typeof selectedLimits[date]?.stay === 'number';

            return (
              <div
                key={date}
                className="relative border-2 border-blue-500 p-2 rounded bg-white cursor-pointer hover:bg-blue-50 transition"
                onClick={() => openSingleDateSetting(date)}
              >
                <div className="text-lg font-bold text-blue-900">{date.slice(5)}</div>

                <div className="absolute top-1 right-1 text-right space-y-0 text-[10px]">
                  {/* 顯示上限 */}
                  <div className="text-gray-700 font-bold">
                    上限：休{leave}＋外{night}
                  </div>

                  {/* 顯示剩餘名額 */}
                  <div className="text-red-900 font-semibold">休剩 {leaveRemain}</div>
                  <div className="text-purple-900 font-semibold">外剩 {whiteRemain}</div>
                  <div className="text-blue-900 font-semibold">白 {getRemainingStay(date)}</div>
                </div>

                {isManual ? (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedLimits(prev => {
                        const copy = { ...prev };
                        delete copy[date];
                        return copy;
                      });
                    }}
                    className="px-2 py-1 bg-blue-500 text-white shadow text-[12px] hover:underline mt-1"
                  >
                    更改為自動計算
                  </button>
                ) : (
                  <div className="text-[12px] text-gray-900 mt-1">目前為自動計算</div>
                )}
              </div>
            );
          })}



          <button
            className="col-span-2 mt-4 bg-green-600 text-white py-2 rounded-xl shadow hover:bg-green-700 transition"
            onClick={saveLeaveLimitsToServer}
          >
            儲存設定
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeaveLimitModal;
